import React, { useState } from "react";
import { Button, Menu, MenuItem } from "@material-ui/core";
import MoreHoriz from "@material-ui/icons/MoreHoriz";

import { FlyerDetailPageTabPageMenuProps } from "./flyer-detail-page-tab-page-menu.props";
import { FileDownload } from "../../../../../../../../features/file-attachments/file-download/components/file-download/file-download-component";
import { exportPageEndPoint } from "../../../../services/flyer-detail.services";

export const FlyerDetailPageTabPageMenu = (props: FlyerDetailPageTabPageMenuProps) => {
  const [menuAnchor, setMenuAnchor] = useState<null | HTMLElement>(null);
  const menuOpen = Boolean(menuAnchor);

  const closeMenu = () => {
    setMenuAnchor(null);
  };

  const openMenu = (event: React.MouseEvent<HTMLElement>) => {
    setMenuAnchor(event.currentTarget);
  };

  return (
    <>
      <Button onClick={openMenu} title="More Options">
        <MoreHoriz />
      </Button>
      <Menu
        anchorEl={menuAnchor}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        getContentAnchorEl={null}
        keepMounted
        MenuListProps={{ onMouseLeave: closeMenu }}
        onClose={closeMenu}
        open={menuOpen}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <MenuItem>
          <FileDownload
            authRequired={true}
            saveAsFileName={`page-${props.pageId}.csv`}
            url={exportPageEndPoint(props.pageId)}
            variant="plainText"
          >
            Export for InDesign
          </FileDownload>
        </MenuItem>

        {props.canDelete && <MenuItem onClick={props.onDelete}>Delete</MenuItem>}
      </Menu>
    </>
  );
};
